<template>
    <div ref="pageBox">
        <SearchBox ref="SearchBox">
            <el-form slot="form" style="display: flex; margin-left: 15vw" :inline="true" ref="searchData"
                     :model="searchParams" label-width="100px" class="unitWidth" size="small">
                <el-form-item style="display: flex" :label="$t('Account.receiptCode')">
                    <el-input :placeholder="$t('Account.system')" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item style="display: flex" :label="$t('Account.receiptType')">
                    <el-select v-model="searchParams.purchaseType" :placeholder="$t('User.select')">
                        <el-option label="采购" value="CG"></el-option>
                        <el-option label="二次利用" value="ST"></el-option>
                        <el-option label="其它" value="OT"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-form slot="form" style="display: flex; margin-left: 15vw" :inline="true" ref="searchData"
                     :model="searchParams" label-width="100px" class="unitWidth" size="small">
                <el-form-item style="display: flex" :label="$t('Shift.factory')">
                    <el-select v-model="searchParams.fcCode" :placeholder="$t('base.PleaseSelect')" :disabled="ischeck"
                               :clearable="isclear" filterable @change="fcChange">
                        <el-option v-for="factory in factoryList" :key="factory.factoryId" :label="factory.fcName"
                                   :value="factory.fcCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="display: flex" :label="$t('Account.storeName')">
                    <el-select v-model="searchParams.strCode" :placeholder="$t('User.select')" clearable filterable
                               @change="sparePartPositionList">
                        <el-option v-for="house in houseList" :key="house.spsId" :label="house.strName"
                                   :value="house.strCode"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-form slot="form" style="display: flex; margin-left: 12.5vw" :inline="true" ref="searchData"
                     :model="searchParams" label-width="140px" class="unitWidth" size="small">
                <el-form-item style="display: flex" :label="$t('Account.purchaseOrderCode')">
                    <el-input v-model.trim="searchParams.purchaseOrderCode"></el-input>
                </el-form-item>
            </el-form>
            <el-form slot="form" style="display: flex; margin-left: 15vw" :inline="true" ref="searchData"
                     :model="searchParams" label-width="100px" class="unitWidth" size="small">
                <el-form-item style="display: flex" :label="$t('Account.remark')">
                    <el-input class="textarea" type="textarea" rows="3" style="width: 31vw !important"
                              :placeholder="$t('base.PleaseEnter')" v-model="searchParams.purchaseDesc"></el-input>
                </el-form-item>
                <el-form-item style="margin-left: 19vw; display: flex; margin-top: 2vw">
                    <el-button size="small" type="primary" @click="addPartPurchaseOrder" :disabled="saveShow">{{$t('base.save')}}
                    </el-button>
                </el-form-item>
            </el-form>
            <el-form style="display: flex; margin-left: 30vw" slot="form" :inline="true" ref="searchData"
                     :model="searchParams" class="unitWidth" size="small">
                <el-form-item :label="$t('Account.preparedBy')">
                    <span>{{ userName }}</span>
                </el-form-item>
                <el-form-item style="margin-left: 2vw" :label="$t('Account.totalPrice')">
                    <span style="color: red">{{ totalPrice }}{{$t('Account.RMB')}}</span>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent ref="LabelContent">
            <div slot="btns">
                <el-button size="small" type="success" @click="addPartInfo()">{{$t('base.add')}}</el-button>
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center" border>
                <el-table-column prop="spCode" :label="$t('Account.spareCode')"/>
                <el-table-column prop="spName" :label="$t('Account.spareName')"/>
                <el-table-column prop="spModel" :label="$t('Account.spareModel')"/>
                <el-table-column prop="unit" :label="$t('Account.unit')"/>
                <el-table-column prop="sppName" :label="$t('Account.locatorName')"/>
                <el-table-column prop="batchNo" :label="$t('Account.batchNo')"/>
                <el-table-column prop="amount" :label="$t('Account.receiptNum')" width="250">
                    <template slot-scope="scope">
                        <el-input-number v-model.trim="scope.row.amount" :min="1"
                                         @change="priceCalculation(scope.row, scope.$index)"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column prop="spPrice" :label="$t('Account.price')"/>
                <el-table-column prop="totalPrice" :label="$t('Account.totalPrice')"/>
                <el-table-column :label="$t('base.operation')" width="100">
                    <template slot-scope="scope">
                        <i class="delBtn iconfont u-shanchu" @click="deletePartInfo(scope)"/>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="入库备件信息" width="40vw" :visible.sync="updateShow" style="text-align: left">
            <el-form :model="sparePartInfo" :rules="partInfo" ref="partInfo" label-width="100px" class="demo-roleForm">
                <!--<el-form-item>
                    <div class="spPartInput">
                        <el-input placeholder="请输入内容" v-model="spData" class="">
                            <el-select v-model="spSelect" slot="prepend" placeholder="请选择" class="spPartSelect">
                                <el-option label="备件编码" value="spCode"></el-option>
                                <el-option label="备件型号" value="spModel"></el-option>
                                <el-option label="单位" value="unit"></el-option>
                            </el-select>
                            <el-button slot="append" icon="el-icon-search" @click="sparePartInfoList"></el-button>
                        </el-input>
                    </div>
                </el-form-item>-->
                <el-form-item label="备件" prop="spCode">
                    <!--                    <el-input v-model="sparePartInfo.spCode"></el-input>-->
                    <el-select
                        v-model="sparePartInfo.spCode"
                        filterable
                        clearable
                        remote
                        reserve-keyword
                        :placeholder="$t('base.PleaseEnter')"
                        :remote-method="remoteMethod"
                        :loading="loading"
                        @change="queryPartInfoBySpCode"
                    >
                        <el-option v-for="item in options" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备件型号">
                    <el-input v-model="sparePartInfo.spModel" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="备件名称">
                    <el-input v-model="sparePartInfo.spName" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="单位">
                    <el-input v-model="sparePartInfo.unit" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="批次号">
                    <el-input v-model="sparePartInfo.batchNo"></el-input>
                </el-form-item>
                <el-form-item label="选择库位" prop="locatorCode">
                    <el-select v-model="sparePartInfo.locatorCode" :placeholder="$t('base.PleaseSelect')" filterable
                               @change="querySpareCode">
                        <el-option v-for="partPosition in partPositionList" :key="partPosition.sppId"
                                   :label="partPosition.sppName" :value="partPosition.sppCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="入库数量" prop="amount">
                    <el-input-number v-model.trim="sparePartInfo.amount" :min="0"
                                     :placeholder="$t('User.input')"></el-input-number>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateShow = false">取 消</el-button>
                <el-button type="primary" @click="updatePartPurchase('partInfo')">确定</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="$t('Account.receiptInfo')" width="75vw" :visible.sync="updateTableShow" style="text-align: left">
            <SearchBox ref="SearchBox">
                <el-form slot="form" :inline="true" :model="sparePartInfo" :rules="partInfo" ref="partInfo"
                         label-width="100px"
                         class="demo-roleForm">
                    <el-form-item :label="$t('Account.spareCode')">
                        <el-input v-model="sparePartInfo.spCode"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Account.spareName')">
                        <el-input v-model="sparePartInfo.spName"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Account.spareModel')">
                        <el-input v-model="sparePartInfo.spModel"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Account.batchNo')">
                        <el-input v-model="sparePartInfo.batchNo"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="searchTable()">{{$t('base.search')}}</el-button>
                    </el-form-item>
                </el-form>
            </SearchBox>
            <div class="tableBox">
                <el-table stripe ref="multipleTable" :data="tableSelectData" tooltip-effect="dark" class="center" border>
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="spName" :label="$t('Account.spareName')"/>
                    <el-table-column prop="spCode" :label="$t('Account.spareCode')" width="150"/>
                    <el-table-column prop="spModel" :label="$t('Account.spareModel')"/>
                    <el-table-column prop="unit" :label="$t('Account.unit')"/>
                    <el-table-column prop="batchNo" :label="$t('Account.batchNo')">
                        <template slot-scope="scope" align="center">
                            <el-input v-model="scope.row.batchNo"
                                      :disabled="scope.row.hasOwnProperty('sptId') ? true : false"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sppCode" :label="$t('Account.locatorName')" width="150">
                        <template slot-scope="scope" align="center">
                            <span v-if="scope.row.hasOwnProperty('sptId') ? true : false">{{scope.row.sppName}}</span>
                            <el-select v-model="scope.row.sppCode" :placeholder="$t('base.PleaseSelect')" filterable
                                       @change="querySelectSpareCode(scope.$index)"
                                       v-if="scope.row.hasOwnProperty('sptId') ? false : true">
                                <el-option v-for="partPosition in partPositionList" :key="partPosition.sppId"
                                           :label="partPosition.sppName" :value="partPosition.sppCode"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" :label="$t('Account.receiptNum')" width="210">
                        <template slot-scope="scope" align="center">
                            <el-input-number v-model.trim="scope.row.amount" :min="0"
                                             :placeholder="$t('User.input')"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('base.operation')" align="center">
                        <template slot-scope="scope" align="center">
                            <div style="display: flex; align-items: center">
                                <div style="margin-left: 0.5vw">
                                    <el-button type="danger" size="mini" icon="el-icon-delete" circle
                                               v-if="scope.row.hasOwnProperty('sptId') ? false : true"
                                               @click="delTable(scope.$index)"></el-button>
                                    <div style="margin-left: 0.5vw"
                                         v-if="scope.row.hasOwnProperty('spiId') ? true : false">
                                        <el-button type="primary" size="mini" icon="el-icon-plus" circle
                                                   @click="addSpareTable(scope.row)"></el-button>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin-left: 65vw">
                    <el-button type="primary" size="mini" icon="el-icon-plus" circle
                               v-if="spareStockShow"
                               @click="addTable"></el-button>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateTableShow = false">{{$t('base.cancel')}}</el-button>
                <el-button type="primary" @click="updateSelectPartPurchase()">{{$t('base.confirm')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { queryByPartInfoSpCode, sparePartLibrary, sparePartPositionList } from '../../../libs/api'
    import moment from 'moment'

    export default {
        name: 'addPartPurchaseOrder',
        data() {
            return {
                saveShow: false,
                spData: '',
                spSelect: 'spCode',
                searchParams: {
                    purchaseAmount: '',
                    purchaseType: '',
                    totalPrice: '',
                    purchaseDesc: '',
                    amount: '',
                    locatorCode: '',
                    batchNo: '',
                    strCode: '',
                    location: '',
                    fcCode: '',
                    purchaseOrderCode: ''
                },
                tableData: [],
                houseList: [],
                updateShow: false,
                loading: false,
                sparePartInfoStock: {},
                spareStockShow: false,
                sparePartInfo: {
                    spCode: '',
                    spModel: '',
                    spName: '',
                    unit: '',
                    locatorCode: '',
                    sppName: '',
                    amount: 1,
                    spiId: '',
                    spPrice: '',
                    totalPrice: '',
                    batchNo: ''
                },
                partInfo: {
                    spCode: [
                        {
                            required: true,
                            message: this.$t('base.PleaseEnter'),
                            trigger: 'blur'
                        }
                    ],
                    locatorCode: [
                        {
                            required: true,
                            message: this.$t('base.PleaseSelect'),
                            trigger: 'blur'
                        }
                    ],
                    amount: [
                        {
                            required: true,
                            message: this.$t('base.PleaseEnter'),
                            trigger: 'blur'
                        }
                    ]
                },
                partInfoList: [],
                options: [],
                value: [],
                list: [],
                userName: '',
                partPositionList: [],
                factoryList: [],
                userInfo: {},
                role: {},
                ischeck: true,
                isclear: false,
                updateTableShow: false,
                tableSelectData: [],
                selectionList: [],
                addSelectShow: false
            }
        },
        computed: {
            totalPrice: function() {
                var totalPrice = 0
                for (let i = 0; i < this.tableData.length; i++) {
                    totalPrice += this.tableData[i].spPrice * this.tableData[i].amount
                }
                return totalPrice
            }
        },
        created() {
            this.userName = this.$store.state.userInfo.userName
            this.init()
        },
        methods: {
            init() {
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getAllFactory()
            },
            deletePartInfo(row) {
                this.tableData.splice(row.$index, 1)
            },
            priceCalculation(row, index) {
                this.tableData[index].totalPrice = row.amount * row.spPrice
            },
            querySpareCode() {
                for (let i = 0; i < this.partPositionList.length; i++) {
                    if (this.partPositionList[i].sppCode == this.sparePartInfo.locatorCode) {
                        this.sparePartInfo.sppName = this.partPositionList[i].sppName
                    }
                }
            },
            updatePartPurchase(partInfo) {
                this.$refs[partInfo].validate((valid) => {
                    if (valid) {
                        if (this.sparePartInfo.amount == 0) {
                            this.$message.info(this.$t('msg.zero'))
                            return
                        }
                        for (let i = 0; i < this.tableData.length; i++) {
                            if (this.tableData[i].sppCode == this.sparePartInfo.locatorCode &&
                                this.tableData[i].spCode == this.sparePartInfo.spCode &&
                                this.tableData[i].batchNo == this.sparePartInfo.batchNo) {
                                this.tableData[i].amount = (this.sparePartInfo.amount + this.tableData[i].amount)
                                this.tableData[i].totalPrice = (this.tableData[i].amount * this.sparePartInfo.spPrice)
                                this.updateShow = false
                                return
                            }
                        }
                        var array = {
                            sppCode: this.sparePartInfo.locatorCode,
                            spCode: this.sparePartInfo.spCode,
                            spModel: this.sparePartInfo.spModel,
                            spName: this.sparePartInfo.spName,
                            unit: this.sparePartInfo.unit,
                            locatorCode: this.sparePartInfo.locatorCode,
                            amount: this.sparePartInfo.amount,
                            spiId: this.sparePartInfo.spiId,
                            spPrice: this.sparePartInfo.spPrice,
                            totalPrice: this.sparePartInfo.totalPrice = (this.sparePartInfo.amount * this.sparePartInfo.spPrice),
                            sppName: this.sparePartInfo.sppName,
                            batchNo: this.sparePartInfo.batchNo
                        }
                        this.tableData.push(array)
                        this.updateShow = false
                    } else {
                        return false
                    }
                })
            },
            addSpareTable(row) {
                let array = {
                    spName: row.spName,
                    spCode: row.spCode,
                    spModel: row.spModel,
                    unit: row.unit,
                    batchNo: '',
                    sppCode: '',
                    amount: 0,
                    spPrice: row.spPrice
                }
                this.tableSelectData.push(array)
            },
            addTable() {
                let array = {
                    spName: this.sparePartInfoStock.spName,
                    spCode: this.sparePartInfoStock.spCode,
                    spModel: this.sparePartInfoStock.spModel,
                    unit: this.sparePartInfoStock.unit,
                    batchNo: '',
                    sppCode: '',
                    amount: 0,
                    spPrice: this.sparePartInfoStock.spPrice
                }
                this.tableSelectData.push(array)
            },
            delTable(index) {
                this.tableSelectData.splice(index, 1)
            },
            querySelectSpareCode(index) {
                for (let i = 0; i < this.partPositionList.length; i++) {
                    if (this.partPositionList[i].sppCode == this.tableSelectData[index].sppCode) {
                        this.tableSelectData[index].sppName = this.partPositionList[i].sppName
                    }
                }
            },
            updateSelectPartPurchase() {
                this.selectionList = this.$refs.multipleTable.selection
                if (this.selectionList.length == 0) {
                    this.$message.error(this.$t('msg.spare'))
                    return
                }
                for (let i = 0; i < this.selectionList.length; i++) {
                    if (this.selectionList[i].sppCode == undefined || this.selectionList[i].sppCode == '') {
                        this.$message.error(this.$t('msg.locator'))
                        return
                    }
                    if (this.selectionList[i].amount == 0) {
                        this.$message.error(this.$t('msg.zero'))
                        return
                    }
                    if (this.selectionList[i].amount == undefined || this.selectionList[i].amount == '') {
                        this.$message.error(this.$t('Account.receiptNum'))
                        return
                    }
                }
                for (let i1 = 0; i1 < this.selectionList.length; i1++) {
                    for (let j = i1 + 1; j < this.selectionList.length; j++) {
                        if (this.selectionList[i1].spCode == this.selectionList[j].spCode &&
                            this.selectionList[i1].sppCode == this.selectionList[j].sppCode &&
                            this.selectionList[i1].batchNo == this.selectionList[j].batchNo) {
                            this.$message.error(this.$t('msg.same'))
                            return
                        }
                    }
                }
                if (this.tableData.length != 0) {
                    for (let a1 = 0; a1 < this.tableData.length; a1++) {
                        for (let a2 = 0; a2 < this.selectionList.length; a2++) {
                            if (this.tableData[a1].sppCode == this.selectionList[a2].sppCode &&
                                this.tableData[a1].spCode == this.selectionList[a2].spCode &&
                                this.tableData[a1].batchNo == this.selectionList[a2].batchNo) {
                                this.tableData[a1].amount = (this.selectionList[a2].amount + this.tableData[a1].amount)
                                this.tableData[a1].totalPrice = (this.tableData[a1].amount * this.selectionList[a2].spPrice)
                                this.selectionList.splice(a2, 1)
                            }
                        }
                    }
                    if (this.selectionList.length != 0) {
                        for (let a3 = 0; a3 < this.selectionList.length; a3++) {
                            let array = {
                                spCode: this.selectionList[a3].spCode,
                                spModel: this.selectionList[a3].spModel,
                                spName: this.selectionList[a3].spName,
                                unit: this.selectionList[a3].unit,
                                amount: this.selectionList[a3].amount,
                                spiId: this.selectionList[a3].spiId,
                                spPrice: this.selectionList[a3].spPrice,
                                totalPrice: this.selectionList[a3].totalPrice = (this.selectionList[a3].amount * this.selectionList[a3].spPrice),
                                sppCode: this.selectionList[a3].sppCode,
                                sppName: this.selectionList[a3].sppName,
                                batchNo: this.selectionList[a3].batchNo
                            }
                            this.tableData.push(array)
                        }
                    }
                } else {
                    for (let a4 = 0; a4 < this.selectionList.length; a4++) {
                        let array = {
                            spCode: this.selectionList[a4].spCode,
                            spModel: this.selectionList[a4].spModel,
                            spName: this.selectionList[a4].spName,
                            unit: this.selectionList[a4].unit,
                            amount: this.selectionList[a4].amount,
                            spiId: this.selectionList[a4].spiId,
                            spPrice: this.selectionList[a4].spPrice,
                            totalPrice: this.selectionList[a4].totalPrice = (this.selectionList[a4].amount * this.selectionList[a4].spPrice),
                            sppCode: this.selectionList[a4].sppCode,
                            sppName: this.selectionList[a4].sppName,
                            batchNo: this.selectionList[a4].batchNo
                        }
                        this.tableData.push(array)
                    }
                }
                this.updateTableShow = false
            },
            addPartInfo() {
                if (this.searchParams.strCode == undefined || this.searchParams.strCode == '') {
                    this.$message.error(this.$t('Account.selectCk'))
                    return
                }
                this.$refs.multipleTable.clearSelection()
                this.tableSelectData = []
                this.spareStockShow = false
                // this.updateShow = true
                this.updateTableShow = true
            },
            addPartPurchaseOrder() {
                if (this.searchParams.purchaseType == undefined || this.searchParams.purchaseType == '') {
                    this.$message.info(this.$t('Account.receiptType'))
                    return
                }
                if (this.searchParams.fcCode == undefined || this.searchParams.fcCode == '') {
                    this.$message.info(this.$t('mechanism.selectFc'))
                    return
                }
                if (this.searchParams.strCode == undefined || this.searchParams.strCode == '') {
                    this.$message.info(this.$t('Account.selectCk'))
                    return
                }
                if (this.tableData.length == 0) {
                    this.$message.info(this.$t('msg.receipt'))
                    return
                }
                /*if (this.searchParams.purchaseDesc == undefined || this.searchParams.purchaseDesc == '') {
                    this.$message.info('请输入入库备注！')
                    return
                }
                if (this.searchParams.purchaseOrderCode == undefined || this.searchParams.purchaseOrderCode == '') {
                    this.$message.info('请输入采购订单号！')
                    return
                }*/
                this.saveShow = true
                let queryParams = {
                    fcCode: this.searchParams.fcCode,
                    purchaseType: this.searchParams.purchaseType,
                    purchaseOrderCode: this.searchParams.purchaseOrderCode,
                    strCode: this.searchParams.strCode,
                    purchaseTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                    purchaseDesc: this.searchParams.purchaseDesc,
                    itemForm: this.tableData
                }
                let options = {
                    method: 'POST',
                    url: this.$api.addPartPurchaseOrder,
                    data: queryParams
                }
                this.$http.request(options).then(response => {
                    this.saveShow = false
                    if (response.status == 100) {
                        this.$message.success(this.$t('base.SuccessfullyAdded'))
                        this.$router.push({
                            name: 'sparePartPurchaseOrder'
                        })
                    } else {
                        this.$message.error(response.message)
                    }
                })
            },
            partStoreHouseList() {
                let params = {}
                if (this.searchParams.fcCode != undefined && this.searchParams.fcCode != '') {
                    params['fcCode'] = this.searchParams.fcCode
                } else {
                    return
                }
                let options = {
                    method: 'get',
                    url: this.$api.partStoreHouseList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.houseList = response.data
                    }
                })
            },
            queryPartInfoBySpCode() {
                let params = {
                    spCode: this.sparePartInfo.spCode,
                    fcCode: this.searchParams.fcCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.queryByPartInfoSpCode,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data != undefined && response.data != '') {
                            this.sparePartInfo.spName = response.data.spName
                            this.sparePartInfo.spBrand = response.data.spBrand
                            this.sparePartInfo.spModel = response.data.spModel
                            this.sparePartInfo.unit = response.data.unit
                            this.sparePartInfo.spiId = response.data.spiId
                            this.sparePartInfo.spPrice = response.data.spPrice
                        } else {
                            this.sparePartInfo.spName = ''
                            this.sparePartInfo.spBrand = ''
                            this.sparePartInfo.spModel = ''
                            this.sparePartInfo.unit = ''
                        }
                    }
                })
            },
            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true
                    setTimeout(() => {
                        this.loading = false
                        this.options = this.list.filter(item => {
                            return item.label.toLowerCase()
                                .indexOf(query.toLowerCase()) > -1
                        })
                    }, 200)
                } else {
                    this.options = []
                }
            },
            remoteList() {
                if (this.partInfoList != undefined && this.partInfoList != '') {
                    this.list = this.partInfoList.map(item => {
                        let infoItem = {}
                        if (this.spSelect == 'spCode') {
                            infoItem = {
                                value: item.spCode,
                                label: item.spCode + '(' + item.spName + ')'
                            }
                        } else if (this.spSelect == 'spModel') {
                            infoItem = {
                                value: item.spCode,
                                label: item.spCode + '(' + item.spModel + ')'
                            }
                        } else if (this.spSelect == 'unit') {
                            infoItem = {
                                value: item.spCode,
                                label: item.spCode + '(' + item.unit + ')'
                            }
                        }
                        return infoItem
                    })
                }
                this.remoteMethod(this.spData)
            },
            sparePartInfoList() {
                let params = {}
                this.partInfoList = []
                if (this.searchParams.fcCode != undefined && this.searchParams.fcCode != '') {
                    params['fcCode'] = this.searchParams.fcCode
                } else {
                    return
                }
                if (this.spSelect != undefined && this.spSelect != '') {
                    params['spSelect'] = this.spSelect
                } else {
                    this.$message.error(this.$t('base.PleaseSelect'))
                    return
                }
                if (this.spData != undefined && this.spData != '') {
                    params['spData'] = this.spData
                }
                let options = {
                    method: 'get',
                    url: this.$api.sparePartInfoList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data != undefined && response.data != '') {
                            this.partInfoList = response.data
                            this.remoteList()
                        }
                    }
                })
            },
            fcChange() {
                if (this.searchParams.fcCode == undefined || this.searchParams.fcCode == '') {
                    this.searchParams.strCode = ''
                    this.houseList = []
                    this.partInfoList = []
                    return
                }
                this.searchParams.strCode = ''
                this.partStoreHouseList()
                this.sparePartInfoList()
            },
            getAllFactory() {
                let options = {
                    method: 'get',
                    url: this.$api.getAllFactory
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.factoryList = []
                        if (this.ischeck) {
                            var aa = response.data
                            var role = JSON.parse(sessionStorage.getItem('userInfo')).roles
                            for (let i = 0; i < aa.length; i++) {
                                for (let j = 0; j < role.length; j++) {
                                    if (aa[i].factoryId == role[j].factoryId) {
                                        this.factoryList.push(aa[i])
                                    }
                                }
                            }
                            this.searchParams.fcCode = this.role.fcCode
                        } else {
                            this.factoryList = response.data
                        }
                        this.partStoreHouseList()
                        this.sparePartInfoList()
                    }
                })
            },
            sparePartPositionList() {
                let queryParams = {}
                if (this.searchParams.strCode != undefined && this.searchParams.strCode != '') {
                    queryParams['strCode'] = this.searchParams.strCode
                } else {
                    return
                }
                let options = {
                    method: 'get',
                    url: this.$api.sparePartPositionList,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.partPositionList = response.data
                    }
                })
            },
            getSparePartInfoSpCode() {
                let queryParams = {}
                if (this.searchParams.fcCode != undefined && this.searchParams.fcCode != '') {
                    queryParams['fcCode'] = this.searchParams.fcCode
                } else {
                    return
                }
                if (this.sparePartInfo.spCode != undefined && this.sparePartInfo.spCode != '') {
                    queryParams['spCode'] = this.sparePartInfo.spCode
                }
                if (this.sparePartInfo.spName != undefined && this.sparePartInfo.spName != '') {
                    queryParams['spName'] = this.sparePartInfo.spName
                }
                if (this.sparePartInfo.spModel != undefined && this.sparePartInfo.spModel != '') {
                    queryParams['spModel'] = this.sparePartInfo.spModel
                }
                let options = {
                    method: 'get',
                    url: this.$api.getSparePartInfoSpCode,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.sparePartInfoStock = JSON.parse(JSON.stringify(response.data))
                        this.spareStockShow = true
                        this.$message.info(this.$t('msg.noStock'))
                    } else {
                        this.spareStockShow = false
                        this.$message.error(response.message)
                    }
                })
            },
            searchTable() {
                this.spareStockShow = false
                let queryParams = {}
                this.tableSelectData = []
                if (this.searchParams.fcCode != undefined && this.searchParams.fcCode != '') {
                    queryParams['fcCode'] = this.searchParams.fcCode
                } else {
                    return
                }
                if ((this.sparePartInfo.spCode == undefined || this.sparePartInfo.spCode == '') &&
                    (this.sparePartInfo.spName == undefined || this.sparePartInfo.spName == '') &&
                    (this.sparePartInfo.spModel == undefined || this.sparePartInfo.spModel == '') &&
                    (this.sparePartInfo.batchNo == undefined || this.sparePartInfo.batchNo == '')) {
                    this.$message.error(this.$t('base.PleaseEnter'))
                    return
                }
                if (this.sparePartInfo.spCode != undefined && this.sparePartInfo.spCode != '') {
                    queryParams['spCode'] = this.sparePartInfo.spCode
                }
                if (this.sparePartInfo.spName != undefined && this.sparePartInfo.spName != '') {
                    queryParams['spName'] = this.sparePartInfo.spName
                }
                if (this.sparePartInfo.spModel != undefined && this.sparePartInfo.spModel != '') {
                    queryParams['spModel'] = this.sparePartInfo.spModel
                }
                if (this.sparePartInfo.batchNo != undefined && this.sparePartInfo.batchNo != '') {
                    queryParams['batchNo'] = this.sparePartInfo.batchNo
                }
                if (this.searchParams.strCode != undefined && this.searchParams.strCode != '') {
                    queryParams['strCode'] = this.searchParams.strCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.sparePartLibrary,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        // this.tableSelectData = response.data
                        if (response.data != undefined && response.data != '') {
                            let tableSelectData = response.data
                            for (let i = 0; i < tableSelectData.length; i++) {
                                let array = {
                                    sptId: '',
                                    sppCode: '',
                                    sppName: '',
                                    amount: '',
                                    batchNo: '',
                                    spiId: '',
                                    spName: '',
                                    spCode: '',
                                    spBrand: '',
                                    spModel: '',
                                    unit: '',
                                    spPrice: ''
                                }
                                array.sptId = tableSelectData[i].sptId
                                array.sppCode = tableSelectData[i].sppCode
                                array.sppName = tableSelectData[i].sppName
                                array.amount = 0
                                array.batchNo = tableSelectData[i].batchNo == undefined || tableSelectData[i].batchNo == '' ? '' : tableSelectData[i].batchNo
                                array.spiId = tableSelectData[i].spiId
                                array.spName = tableSelectData[i].spName
                                array.spCode = tableSelectData[i].spCode
                                array.spBrand = tableSelectData[i].spBrand
                                array.sptId = tableSelectData[i].sptId
                                array.spModel = tableSelectData[i].spModel
                                array.unit = tableSelectData[i].unit
                                array.spPrice = tableSelectData[i].spPrice
                                this.tableSelectData.push(array)
                            }
                        } else {
                            this.getSparePartInfoSpCode()
                        }
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .el-textarea__inner {
        width: 31vw !important;
    }

    .spPartSelect {
        max-width: 200px;
    }

    .spPartInput, el-input__inner {
        max-width: 200px;
        margin-left: -70px;
    }

    .input-with-select .el-input-group__prepend {
        background-color: #fff;
    }

    .spPartInput {
        ::v-deep .el-select > .el-input {
            width: 80px !important;
        }

        ::v-deep .el-input__inner {
            width: 200px !important;
        }
    }
</style>
